import { createElement } from "react";
import React from "react";
import * as react from "react";
import { TaskMsg, useFeliz_UseElmish_React__React_useTaskDispatch_Static } from "../hooks/UseTaskDispatch.fs.js";
import { reactApi } from "../fable_modules/Feliz.2.9.0/./Interop.fs.js";
import { singleton, cons, ofArray, empty } from "../fable_modules/fable-library-js.4.24.0/List.js";
import { PromiseBuilder__Delay_62FBFDE1, PromiseBuilder__Run_212F1D4B } from "../fable_modules/Fable.Promise.3.2.0/Promise.fs.js";
import { isNullOrWhiteSpace } from "../fable_modules/fable-library-js.4.24.0/String.js";
import { promise } from "../fable_modules/Fable.Promise.3.2.0/PromiseImpl.fs.js";
import { newGuid } from "../fable_modules/fable-library-js.4.24.0/Guid.js";
import { Users_SetUserPermissions } from "../ServerTypes.fs.js";
import { removeFromProject, addToProject } from "../Api/Users.fs.js";
import { Modal_ModalWithBreakdown } from "./Modal.fs.js";
import { createObj } from "../fable_modules/fable-library-js.4.24.0/Util.js";
import { Helpers_combineClasses } from "../fable_modules/Feliz.Bulma.3.0.0/./ElementBuilders.fs.js";
import { PermissionSelector_ScopeSelector } from "../components/Components.fs.js";
import { map, defaultArg } from "../fable_modules/fable-library-js.4.24.0/Option.js";
import { FSharpMap__TryFind } from "../fable_modules/fable-library-js.4.24.0/Map.js";

export function AddUserToProject(addUserToProjectInputProps) {
    let xs_12, elms_1, elms, elms_3, elms_2, elms_4;
    const close = addUserToProjectInputProps.close;
    const projectId = addUserToProjectInputProps.projectId;
    const patternInput = useFeliz_UseElmish_React__React_useTaskDispatch_Static();
    const taskDispatch = patternInput[1];
    const patternInput_1 = reactApi.useState("");
    const name = patternInput_1[0];
    const patternInput_2 = reactApi.useState("");
    const email = patternInput_2[0];
    const patternInput_3 = reactApi.useState(empty());
    const permissions = patternInput_3[0];
    let create;
    const dependencies_1 = [name, email, permissions];
    create = reactApi.useCallback(() => {
        const pr = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
            if (isNullOrWhiteSpace(name)) {
                return Promise.resolve();
            }
            else {
                const taskId = newGuid();
                taskDispatch(new TaskMsg(0, [taskId, "Add User"]));
                const newUser = new Users_SetUserPermissions(email, name, permissions);
                taskDispatch(new TaskMsg(2, [taskId]));
                return addToProject(projectId, newUser).then((_arg) => {
                    const result = _arg;
                    if (result.tag === 1) {
                        taskDispatch(new TaskMsg(6, [taskId, result.fields[0]]));
                        return Promise.resolve();
                    }
                    else {
                        taskDispatch(new TaskMsg(3, [taskId, undefined]));
                        return Promise.resolve();
                    }
                });
            }
        }));
        void pr;
    }, dependencies_1);
    return createElement(Modal_ModalWithBreakdown, {
        close: close,
        content: (xs_12 = [(elms_1 = ofArray([createElement("label", {
            className: "label",
            children: "Name",
        }), (elms = singleton(createElement("input", createObj(cons(["type", "text"], Helpers_combineClasses("input", ofArray([["onChange", (ev) => {
            patternInput_1[1](ev.target.value);
        }], ["placeholder", "David Barker"], ["defaultValue", name]])))))), createElement("div", {
            className: "control",
            children: reactApi.Children.toArray(Array.from(elms)),
        }))]), createElement("div", {
            className: "field",
            children: reactApi.Children.toArray(Array.from(elms_1)),
        })), (elms_3 = ofArray([createElement("label", {
            className: "label",
            children: "Email",
        }), (elms_2 = singleton(createElement("input", createObj(cons(["type", "email"], Helpers_combineClasses("input", ofArray([["onChange", (ev_1) => {
            patternInput_2[1](ev_1.target.value);
        }], ["placeholder", "david.barker@unasys.com"], ["defaultValue", email]])))))), createElement("div", {
            className: "control",
            children: reactApi.Children.toArray(Array.from(elms_2)),
        }))]), createElement("div", {
            className: "field",
            children: reactApi.Children.toArray(Array.from(elms_3)),
        })), (elms_4 = ofArray([createElement("label", {
            className: "label",
            children: "Scope",
        }), createElement(PermissionSelector_ScopeSelector, {
            initialValues: permissions,
            onChange: patternInput_3[1],
        })]), createElement("div", {
            className: "field",
            children: reactApi.Children.toArray(Array.from(elms_4)),
        }))], react.createElement(react.Fragment, {}, ...xs_12)),
        submit: create,
        submitText: "Add",
        tasks: patternInput[0],
        title: "Add User To Project",
    });
}

export function ChangePermissions(changePermissionsInputProps) {
    let elms;
    const close = changePermissionsInputProps.close;
    const user = changePermissionsInputProps.user;
    const projectId = changePermissionsInputProps.projectId;
    const patternInput = useFeliz_UseElmish_React__React_useTaskDispatch_Static();
    const taskDispatch = patternInput[1];
    let patternInput_1;
    const initial = defaultArg(map((p) => p.Permissions, FSharpMap__TryFind(user.Projects, projectId)), empty());
    patternInput_1 = reactApi.useState(initial);
    const permissions = patternInput_1[0];
    let create;
    const dependencies_1 = [permissions];
    create = reactApi.useCallback(() => {
        const pr = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
            const taskId = newGuid();
            taskDispatch(new TaskMsg(0, [taskId, `Change Permissions for User: ${user.Name}`]));
            const newUser = new Users_SetUserPermissions(user.Email, user.Name, permissions);
            taskDispatch(new TaskMsg(2, [taskId]));
            return addToProject(projectId, newUser).then((_arg) => {
                const result = _arg;
                if (result.tag === 1) {
                    taskDispatch(new TaskMsg(6, [taskId, result.fields[0]]));
                    return Promise.resolve();
                }
                else {
                    taskDispatch(new TaskMsg(3, [taskId, undefined]));
                    return Promise.resolve();
                }
            });
        }));
        void pr;
    }, dependencies_1);
    return createElement(Modal_ModalWithBreakdown, {
        close: close,
        content: (elms = ofArray([createElement("label", {
            className: "label",
            children: "Scope",
        }), createElement(PermissionSelector_ScopeSelector, {
            initialValues: permissions,
            onChange: patternInput_1[1],
        })]), createElement("div", {
            className: "field",
            children: reactApi.Children.toArray(Array.from(elms)),
        })),
        submit: create,
        submitText: "Change",
        tasks: patternInput[0],
        title: "Change Permissions",
    });
}

export function RemoveFromProject(removeFromProjectInputProps) {
    let initial, elems;
    const close = removeFromProjectInputProps.close;
    const user = removeFromProjectInputProps.user;
    const projectId = removeFromProjectInputProps.projectId;
    const patternInput = useFeliz_UseElmish_React__React_useTaskDispatch_Static();
    const taskDispatch = patternInput[1];
    let create;
    const dependencies_1 = [((initial = defaultArg(map((p) => p.Permissions, FSharpMap__TryFind(user.Projects, projectId)), empty()), reactApi.useState(initial)))[0]];
    create = reactApi.useCallback(() => {
        const pr = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
            const taskId = newGuid();
            taskDispatch(new TaskMsg(0, [taskId, `Remove User: ${user.Name} from project`]));
            taskDispatch(new TaskMsg(2, [taskId]));
            return removeFromProject(projectId, user.Id).then((_arg) => {
                const result = _arg;
                if (result.tag === 1) {
                    taskDispatch(new TaskMsg(6, [taskId, result.fields[0]]));
                    return Promise.resolve();
                }
                else {
                    taskDispatch(new TaskMsg(3, [taskId, undefined]));
                    return Promise.resolve();
                }
            });
        }));
        void pr;
    }, dependencies_1);
    return createElement(Modal_ModalWithBreakdown, {
        close: close,
        content: createElement("div", createObj(Helpers_combineClasses("", singleton((elems = ["Are you sure you want to remove", createElement("em", {
            children: [`${user.Name} <${user.Email}>`],
        }), "from the project?"], ["children", reactApi.Children.toArray(Array.from(elems))]))))),
        submit: create,
        submitText: "Remove",
        tasks: patternInput[0],
        title: "Remove user form project",
    });
}

